module.exports = __webpack_public_path__ + "static/media/instagram.4bdea24a.svg";